import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl45ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
